module.exports = __webpack_public_path__ + "img/SA.d3a9e837.png";